/* eslint-disable prettier/prettier */
import { DashboardPage } from '../pages/DashboardPage';
import { FilesPage } from '../pages/files/FilesPage';
import { ComparePage } from '../pages/compare/ComparePage';
import { FileViewerPage } from '../pages/files/FileViewerPage';
import { ComparePVPage } from '../pages/compare/ComparePV';
import { ComparePVDetailsPage } from '../pages/compare/ComparePVDetailsPage';
import { CompaniesPage } from '../pages/companies/CompaniesPage';
import { UsersPage } from '../pages/users/UsersPage';
import { InvitationsPage } from '../pages/invitations/InvitationsPage';
import { SuperAdminDashboard } from '../pages/dashboards/SuperAdminDashboard';
import { CompanyAdminDashboard } from '../pages/dashboards/CompanyAdminDashboard';
import { UserDashboard } from '../pages/dashboards/UserDashboard';
import { RoleRedirect } from '../components/RoleRedirect';
import { FoldersPage } from '../pages/folders/FoldersPage';
import { RolesPage } from '../pages/roles/RolePage';
import { SearchResultsPage } from '../pages/dashboards/SearchResultsPage';
import { CompanySettingsPage } from '../pages/companies/CompanySettingsPage';
import { ComparePYPage } from '../pages/compare/ComparePY';
import { ComparePPPage } from '../pages/compare/ComparePP';
import { ProgramDefinitionPage } from '../pages/companies/ProgramDefinitionPage';
import { SheetsPage } from '../pages/companies/SheetsPage';

export const ROUTES = [
  { path: '/', element: <RoleRedirect />, roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'USER'] },
  { path: '/invitations', element: <InvitationsPage />, roles: ['SUPER_ADMIN'] },
  { path: '/files', element: <FilesPage />, roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'USER'] },
  { path: '/compare', element: <ComparePage />, roles: ['COMPANY_ADMIN', 'USER'] },
  { path: '/companies', element: <CompaniesPage />, roles: ['SUPER_ADMIN'] },
  { path: '/users', element: <UsersPage />, roles: ['SUPER_ADMIN'] },
  { path: '/company-settings', element: <CompanySettingsPage />, roles: ['COMPANY_ADMIN'] },
  { path: '/company-settings/users', element: <UsersPage />, roles: ['COMPANY_ADMIN'] },

  { path: '/company-settings/invitations', element: <InvitationsPage />, roles: ['COMPANY_ADMIN'] },

  { path: '/company-settings/roles', element: <RolesPage />, roles: ['COMPANY_ADMIN'] },

    { path: '/company-settings/program-definition', element: <ProgramDefinitionPage />, roles: ['COMPANY_ADMIN'] },
    { path: '/company-settings/cedants-brokers', element: <SheetsPage />, roles: ['COMPANY_ADMIN'] },


  { path: '/compare/compare-pv', element: <ComparePVPage />, roles: ['COMPANY_ADMIN', 'USER'] },

  { path: '/compare/compare-py', element: <ComparePYPage />, roles: ['COMPANY_ADMIN', 'USER'] },

    { path: '/compare/compare-pp', element: <ComparePPPage />, roles: ['COMPANY_ADMIN', 'USER'] },


  /*{ path: '/compare-pv', element: <ComparePVPage />, roles: ['COMPANY_ADMIN', 'USER'] },*/
  { path: '/folders', element: <FoldersPage />, roles: ['COMPANY_ADMIN', 'USER'] },
  {
    path: '/search',
    element: <SearchResultsPage />,
    roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'USER'],
  },
  {
    path: '/compare/compare-pv/:id',
    element: <ComparePVDetailsPage />,
    roles: ['COMPANY_ADMIN', 'USER'],
  },

  { path: 'compare/compare-py/:id', element: <ComparePVDetailsPage />, roles: ['COMPANY_ADMIN', 'USER'] },
  {
    path: '/files/:id',
    element: <FileViewerPage />,
    roles: ['SUPER_ADMIN', 'COMPANY_ADMIN', 'USER'],
  },
];
